module.exports = __webpack_public_path__ + "img/old_meleze_grey.a4c13869.jpg";